module.exports = __webpack_public_path__ + "static/media/ink-500_2.d7b02940.png";